import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
`;

export const ButtonRow = styled(Row)`
  padding-bottom: 24px;
`;

export const TextBox = styled.div<any>`
  color: ${props => props.grey ? '#757989' : '#183558'};
  text-align: ${props => props.alignment ? props.alignment : 'left'};
  font-weight: ${props => props.bold ? 700 : 400};
  padding-top: ${props => props.paddingTop};
  padding-bottom: 24px;
`;

export const NumberedList = styled.ol`
  padding-left: 24px;
`;
